import { render, staticRenderFns } from "./ShowAgent.vue?vue&type=template&id=18157ef0"
import script from "./ShowAgent.vue?vue&type=script&lang=js"
export * from "./ShowAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports